<template>
<div style="min-width:1500px">
    <div class="pink-wrap">
        <div class="content clear">
            <div class="lft" style="width:754px">
                <h1>Win new customers with Beny</h1>
                <p class="top_tip">Turn your offer into a Beny-fit and reach our growing community of active users.</p>
                <p class="top_newTip">
                    The Beny network spans across thousands of Australian businesses providing an expansive range of B2B products and services. Your organisation can be a part of our circle. 
                </p>
                <button @click="contactShow(true)">Become a partner</button>
            </div>
            <div class="rgt"></div>
        </div>
    </div>
    <div class="balck-wrap2">
        <div class="svgLine_box">
            <svg
            preserveAspectRatio="none"
            viewBox="-450 -450 900 900"
            xmlns="http://www.w3.org/2000/svg"
            style="fill:#302E2C; width: 100%; height: 90px;"
            >
                <path d='M-466,-11 C0,-769 381,-148 453,-5'/>
            </svg>
        </div>
        <div class="content2">
            <div class="new_center">
                <h1>Why partner with Beny?</h1>
                <div class="pic-text clear">
                    <div class="lft"></div>
                    <div class="rgt">
                        <div class="boxs clear">
                            <div class="box">
                                <h2>Win more customers</h2>
                                <p>
                                    Instantly reach a huge audience across Australia, ready to select your offer.
                                </p>
                            </div>
                            <div class="box">
                                <h2>Get return on investment</h2>
                                <p>Achieve a win-win solution for your organisation with little or no upfront cost.</p>
                            </div>
                            <div class="box">
                                <h2>Be part of a community</h2>
                                <p>Partners of Beny are part of our mission, focused on wellbeing and supporting good causes.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <h2 class="new_titNox">Become a Beny Partner</h2>
            <p class="new_tips">Interested in partnering up with Beny for Business? Get in contact today to offer your benefits and win more customers.</p>
            <div class="new_btn">Become a Partner</div>
            <p style="width: 100%;height: 5px;"></p>
        </div>
        <div class="svgLine_box svgLine_box_new" style="margin-top:-43px;margin-bottom: 0;">
            <svg
            preserveAspectRatio="none"
            viewBox="-450 -450 900 900"
            xmlns="http://www.w3.org/2000/svg"
            style="fill:#302E2C; width: 100%; height: 90px;"
            >
                <path d='M-472,-34 C0,709 186,223 449,-15'/>
            </svg>
        </div>
    </div>
    <div class="bottom_box"></div>
    <div class="gray-line"></div>

    <contact :show="showContact" @close="contactShow" defaultType="Become a Beny partner" />
</div>
</template>

<script>
import contact from '@/components/common/contact.vue'

export default {
    data () {
        return {
            showContact: false
        }
    },
    methods: {
        contactShow(boo) {
            this.showContact = boo
        }
    },
    components: {
        contact
    }
}
</script>

<style lang="scss" scope>
.gray-line{
    border-top: 1px solid #5E5C59;
}
.pink-wrap{
    width: 100%;
    box-sizing: border-box;
    height: 634px;
    background: #F1DADD;
    .content{
        width: 1320px;
        margin: 0 auto;
        .rgt{
            width: 506px;
            float: right;
            height: 595px;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center center;
            background-image: url('https://beny-admin-bucket.s3.us-west-2.amazonaws.com/png/2023/08/03/5cf9257cd4064ccd8ecb58b4399842c9.png');
            position: relative;
            top: 90px;
        }
        .lft{
            float: left;
            width: 754px;
            padding-top: 160px;
            h1{
                word-break: break-word;
                margin-bottom: 40px;
                font-size: 52px;
                font-family: DIN Next LT Pro-Black, DIN Next LT Pro;
                line-height: 54px;
                color: #3A3835;
            }
            h2{
                word-break: break-word;
                font-size: 18px;
                font-family: Assistant;
                font-weight: 400;
                line-height: 22px;
                color: #000000;
                margin-bottom: 24px;
            }
            .top_tip{
                font-size: 22px;
                font-family: Lora-Regular, Lora;
                font-weight: 400;
                color: #3A3835;
                line-height: 28px;
                margin: 20px 0 12px 0;
            }
            .top_newTip{
                font-size: 17px;
                font-family: Assistant-Medium, Assistant;
                font-weight: 500;
                color: #3A3835;
                line-height: 21px;
                margin-bottom: 20px;
            }
            button{
                cursor: pointer;
                width: 222px;
                height: 54px;
                background: #F8A4AE;
                border-radius: 4px;
                border: none;
                font-size: 17px;
                font-family: Assistant-Bold;
                font-weight: bold;
                color: #3A3835;
            }
        }
    }
}
.balck-wrap2{
    width: 100%;
    box-sizing: border-box;
    // background: #33312f;
    margin-top: 187px;
    position: relative;
    .line p{
        font-size: 20px;
        font-family: Lora;
        font-weight: normal;
        line-height: 30px;
        color: #FFFFFF;
        word-break: break-word;
        margin-bottom: 24px;
    }
    button{
        cursor: pointer;
        width: 222px;
        height: 54px;
        background: #F8A4AE;
        border-radius: 4px;
        border: none;
        font-size: 17px;
        font-family: Assistant;
        font-weight: bold;
        color: #3A3835;
    }
    p:nth-child(3){
        margin-bottom: 44px;
    }
    .svgLine_box_new{
        position: absolute;
        bottom: -50px;
    }
    .content2{
        width: 100%;
        background-color: #312f2d;
        .new_center{
            width: 1220px;
            margin: 0 auto;
            padding-bottom: 10px;
        }
        .employeesBox{
            padding-top: 30px;
            h3{
                text-align: center;
                width: 100%;
                font-size: 18px;
                font-weight: 400;
                line-height: 27px;
                color: #FFFFFF;
                opacity: 0.8;
            }
            .employees_iconList{
                margin: 34px 0 139px 0;
                text-align: center;
                height: 26px;
                align-items: center;
                .employees_icon{
                    height: 20px;
                    margin-right: 55px;
                }
            }
        }
        h1{
            font-size: 40px;
            font-family: Assistant;
            font-weight: bold;
            line-height: 56px;
            color: #FFFFFF;
            margin-bottom: 30px;
            text-align: center;
        }
        h3{
            font-size: 17px;
            font-family: Assistant;
            font-weight: 400;
            line-height: 25px;
            color: #FFFFFF;
            opacity: 0.8;
            margin-bottom: 35px;
            text-align: center;
        }
        .pic-text{
            width: 100%;
            box-sizing: border-box;
            padding: 36px 0;
            display: flex;
            align-items: center;
            justify-content: center;
            .lft{
                width: 500px;
                height: 412px;
                background-repeat: no-repeat;
                background-size: cover;
                background-position: center center;
                background-image: url('https://beny-admin-bucket.s3.us-west-2.amazonaws.com/png/2023/08/03/123d68f95560401fac408295cd945b27.png');
                margin-right: 140px;
            }
            .rgt{
                position:relative;
                // width: 680px;
               .boxs{
                    box-sizing: border-box;
                    .box{
                        width: 360px;
                        padding-top: 67px;
                        background-repeat: no-repeat;
                        background-position: left top;
                        margin-bottom: 20px;
                        h2{
                            margin-bottom: 12px;
                            font-size: 22px;
                            font-family: Lora;
                            font-weight: normal;
                            line-height: 27px;
                            color: #FFFFFF;
                            word-break: break-word;
                        }
                        p{
                            font-size: 17px;
                            font-family: Assistant;
                            font-weight: 400;
                            line-height: 21px;
                            color: #FFFFFF;
                            opacity: 0.8;
                            word-break: break-word;
                        }
                    }
                    .box:nth-child(1){
                        background-size: 44px auto;
                        background-image: url('../../assets/benefits/4.png');
                    }
                    .box:nth-child(2){
                        background-size: auto 44px;
                        background-image: url('../../assets/benefits/5.png');
                        margin-right: 0;
                    }
                    .box:nth-child(3){
                        background-size: 44px auto;
                        background-image: url('../../assets/benefits/6.png');
                        margin-right: 0;
                    }
                }
            }
        }
    }
}
.new_titNox{
    font-size: 40px;
    font-family: Assistant-Bold, Assistant;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 47px;
    text-align: center;
}
.new_tips{
    font-size: 17px;
    font-family: Assistant-Medium, Assistant;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 20px;
    text-align: center;
    margin: 20px 0;
}
.new_btn{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 242px;
    height: 54px;
    background: #F8A4AE;
    font-size: 17px;
    font-family: Assistant-Bold, Assistant;
    font-weight: bold;
    color: #3A3835;
    border-radius: 4px;
    margin: 0 auto 0 auto;
}
.svg-bdg{
    background-image: url('../../assets/benefits/bdg.png');
    background-position: top;
    background-size: 100% 140px;
    background-repeat: no-repeat;
}
.svgLine_box{
    width: 100%;
    overflow: hidden;
    margin-bottom: -51px;
}
.svgLine_box-carouselCard{
    width: 100%;
    overflow: hidden;
    margin-top: -250px;
}
.rotate{
    transform:rotate(180deg);
    -ms-transform:rotate(180deg); 	/* IE 9 */
    -moz-transform:rotate(180deg); 	/* Firefox */
    -webkit-transform:rotate(180deg); /* Safari 和 Chrome */
    -o-transform:rotate(180deg); 	/* Opera */
    position: absolute;
    left: 0;
    bottom: 7px;
}
.bottom_box{
    width: 100%;
    height: 200px;
}
</style>


// WEBPACK FOOTER //
// src/components/benefits/beapartner.vue